import { Qualifier } from './Qualifier';
import { IQualifier } from './IQualifier';

export class LinkedAccountQualifier extends Qualifier {
    public static readonly CLASS: string = 'com.bancvue.rcx.config.product.qualifiers.api.LinkedAccountQualifier';

    public static readonly NAME: string = 'Linked Account';

    constructor(qual?: IQualifier) {
      super(LinkedAccountQualifier.CLASS, qual ? qual.id : null);
    }

    /* eslint-disable class-methods-use-this */
    getDescription(): string {
      return 'Primary account qualifies';
    }
    /* eslint-enable class-methods-use-this */

    clone(): IQualifier {
      const clone = new LinkedAccountQualifier();
      Object.assign(clone, this);
      return clone;
    }
}

export default LinkedAccountQualifier;
